export enum PeopleTypes {
  Roster = "roster",
  Staff = "staff",
}
